<template>
  <v-row>
    <v-col sm="12">
      <v-card>
        <v-card-title>
          <!-- <v-icon @click="pushRouteToView('suppliers')" class="mr-4" style="cursor: pointer">
                        mdi-arrow-left
                    </v-icon>-->
          <v-btn
            small
            @click="pushRouteToView('suppliers')"
            class="mr-4 btn-back"
          >
            <v-icon> mdi-arrow-left </v-icon>
            Voltar
          </v-btn>
          <v-icon left>mdi-factory</v-icon>
          Dados do Fornecedor
          <v-spacer></v-spacer>
          <v-btn outlined class="btn-del" @click="dialogDeleteSupplier = true">
            <v-icon left>mdi-delete</v-icon>
            Excluir
          </v-btn>

          <v-btn
            outlined
            :class="`${supplier.active ? 'btn-inactive' : 'btn-active'} mx-2`"
            @click="dialogActiveInactive = true"
          >
              <span v-if="supplier.active"><v-icon left>mdi-diameter-variant</v-icon>Inativar</span><span v-else><v-icon
              left>mdi-checkbox-marked-circle-outline</v-icon>Ativar</span>
              <!--<v-icon left>mdi-pencil</v-icon>
            <span v-if="supplier.active">Inativar</span
            ><span v-else>Ativar</span>-->
          </v-btn>

          <v-btn
            :to="{ name: 'supplierEdit', params: { id: supplier.id } }"
            class="btn-edit"
          >
            <v-icon left>mdi-pencil</v-icon>
            Editar
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-data-visualization">
          <v-card style="border-left: solid 10px #3d1159 !important">
            <v-card-title> </v-card-title>

            <v-card-text class="text-data-visualization">
              <v-row>
                <v-col xl="8" lg="8" md="8" sm="6">
                  <b><v-icon left>mdi-factory</v-icon> Razão Social:</b>
                  {{ supplier.name }}
                </v-col>
                <v-col xl="4" lg="4" md="4" sm="6">
                  <b>
                    <v-icon left>mdi-card-account-details-outline</v-icon
                    >CNPJ:</b
                  >
                  {{ supplier.cnpj }}
                </v-col>
              </v-row>
              <v-row>
                <v-col xl="6" lg="6" md="6" sm="6">
                  <b><v-icon>mdi-phone</v-icon> Telefone:</b>
                  {{ supplier.phone }}
                </v-col>
                <v-col xl="6" lg="6" md="6" sm="6">
                  <b><v-icon>mdi-account</v-icon> Representante:</b>
                  {{ supplier.representative }}
                </v-col>
              </v-row>
              <v-row>
                <v-col xl="12" lg="12" md="12" sm="12">
                  <b><v-icon>mdi-format-align-justify</v-icon> Observação:</b>
                  {{ supplier.obs }}
                </v-col>
              </v-row>
              <v-row>
                <v-col xl="12" lg="12" md="12" sm="12">
                  <b><v-icon>mdi-map-marker</v-icon> Endereço:</b>
                  {{ supplier.address }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-alert type="warning" outlined v-show="!supplier"
          >Nenhum fornecedor encontrado
        </v-alert>
        <confirm-dialog
          :dialog="dialogActiveInactive"
          :title="`${supplier.active ? 'INATIVAR ' : 'ATIVAR '} ${
            supplier.name
          }`"
          body="Tem certeza que desenha realizar essa ação?"
          @dialog-event="inactiveActive"
        >
        </confirm-dialog>
        <confirm-dialog
          :dialog="dialogDeleteSupplier"
          :title="`EXCLUIR  ${supplier.name}`"
          :body="`Tem certeza que deseja excluir o fornecedor ${supplier.name} ?`"
          @dialog-event="deleteSupplier"
        >
        </confirm-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { mask } from "vue-the-mask";
import ConfirmDialog from "@/components/ConfirmDialog";

import {
  SUPPLIER_ACTIVE,
  SUPPLIER_DELETE,
  SUPPLIER_GET,
  SUPPLIER_INACTIVE,
} from "@/store/actions/supplier.type";
import {
  SET_SUPPLIER_ACTIVE,
  SUPPLIER_RESET_STATE,
} from "@/store/mutations/supplier.type";
import { CHANGE_PROGRESS } from "@/store/mutations/mutations.type";

export default {
  name: "supplier",
  directives: { mask },
  props: {
    id: {
      default: 0,
      type: Number,
      required: true,
    },
  },

  components: { ConfirmDialog },
  async beforeRouteUpdate(to, from, next) {
    // Reset state if user goes from /editor/:id to /editor
    // The component is not recreated so we use to hook to reset the state.
    await store.dispatch(SUPPLIER_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    Promise.all([
      await store.dispatch(SUPPLIER_RESET_STATE),
      await store.dispatch(SUPPLIER_GET, to.params.id),
    ]).then(() => {
      next();
    });
  },
  data: () => ({
    formIsValid: false,

    dialogActiveInactive: false,
    dialogDeleteSupplier: false,
  }),
  methods: {
    pushRouteToView(route) {
      this.$router.push({ name: route });
    },
    //Methods Lista Usuarios
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dados.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    deleteSupplier(status) {
      this.dialogDeleteSupplier = false;
      if (!status) {
        return;
      }
      this.$store.commit(CHANGE_PROGRESS, true);
      this.$store
        .dispatch(SUPPLIER_DELETE)
        .then(() => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "success";
          this.snackbar.text = "Excluído com sucesso";

          this.$router.push({
            name: "suppliers",
          });
        })
        .catch(({ response }) => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "error";
          this.snackbar.text = "Erro ao excluir.";
          // console.log(response.data);
          if (typeof response.data.message !== "undefined") {
            this.snackbar.text = response.data.message;
          }
        });
    },
    inactiveActive(status) {
      this.dialogActiveInactive = false;
      if (!status) {
        return;
      }
      let action = this.supplier.active ? SUPPLIER_INACTIVE : SUPPLIER_ACTIVE;
      this.$store.commit(CHANGE_PROGRESS, true);

      this.$store
        .dispatch(action, this.supplier.id)
        .then(() => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "success";
          this.snackbar.text = "Alterado com sucesso";
          this.$store.commit(SET_SUPPLIER_ACTIVE, !this.supplier.active);
        })
        .catch(({ response }) => {
          this.$store.commit(CHANGE_PROGRESS, false);
          this.snackbar.snackbar = true;
          this.snackbar.color = "error";
          this.snackbar.text = "Erro ao alterar.";
          // console.log(response.data);
          if (typeof response.data.message !== "undefined") {
            this.snackbar.text = response.data.message;
          }
        });
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["supplier", "snackbar", "inProgress", "checkUsers"]),
  },
  watch: {},
};
</script>
